<template>
    <div :class="['item-inner-holder', {'empty-list': tasks?.length === 0}]" @mouseover="$emit('mouseover')">
        <div class="list-heading">
            <div class="list-heading-inner">
                <div class="list-title">{{ listTitle }}</div>
                <Dropmenu
                    v-if="extendedList"
                    :id="`listoptions-${listItem.id}`"
                    class="dropmenu-holder"
                    :right="true"
                    :showList="listItem.openListOptions"
                >
                    <template #button>
                        <a href="#" @click.prevent="toggleListOptionsPopUp()">
                            <i class="icon-dots-horizontal-triple" style="color: #fff;"></i>
                        </a>
                    </template>
                    <template #dropcontent>
                        <ul class="dropmenu-list">
                            <li>
                                <a href="#" @click.prevent="openEditModal('edit-list')">
                                    <i class="icon-edit-small"></i>
                                    <span>Edit</span>
                                </a>
                            </li>
                            <li>
                                <a href="#" @click.prevent="archiveList">
                                    <i class="icon-archive-dropdown"></i>
                                    <span>Archive</span>
                                </a>
                            </li>
                        </ul>
                    </template>
                </Dropmenu>
            </div>
	    
            <div class="corresponding_boards" v-if="corresponding_boards">
                <i class="icon-question-mark">
                    <Tooltip position="tr">
                        <div class="tooltip__blue-text mg-btt-15">Tasks are from these projects:</div>
                        <ul>
                            <li v-for="board in corresponding_boards" class="tooltip__item tooltip__li">{{ corresponding_boards_formatted(board) }}</li>
                        </ul>
                    </Tooltip>
                </i>
            </div>
    
        </div>
        <div v-if="$route.name !== 'SmartList'" class="items-block">
            <Container
                drag-class="task-card-ghost"
                drop-class="task-card-ghost-drop"
                :drop-placeholder="dropPlaceholderOptions"
                :get-child-payload="getCardPayload(listItem)"
                group-name="2"
                @drop="onCardDrop($event)"
                @drag-start="dragstart"
            >
                <Draggable
                    v-for="(task, taskIndex) in tasks"
                    :key="taskIndex"
                    :class="[task.id, 'single-task-card']"
                >
                    <TaskCard
                        :key="'i' + taskIndex"
                        :task="task"
                        :listItem="listItem"
                        @openEditTask="openEditTask"
                    />
                </Draggable>
            </Container>
        </div>
        <div v-else class="items-block">
            <div class="smooth-dnd-container vertical">
                <div 
                    v-for="(task, taskIndex) in tasks"
                    :key="taskIndex"
                    :class="['single-task-card', `${task.id}` ]"
                >
                    <TaskCard
                        :key="'i' + taskIndex"
                        :task="task"
                        :listItem="listItem"
                        @openEditTask="openEditTask"
                    />
                </div>
            </div>
        </div>
        <div class="new-task-wrapper" v-if="extendedList">
            <div
                v-show="list.newTask && list.id == listItem.id"
                name="new-task"
                class="new-task"
            >
                <Textfield
                    id="new_task_title"
                    placeholder="Enter a title for this New Task"
                    ref="add-task-title-input"
                    autocomplete="off"
                    @keydownenter="createTask"
                    @keydownesc="cancelCreatingTask"
                    v-model="addTaskTitle"
                />
                <div class="btn-holder">
                    <VButton @clickHandler="createTask" active class="add-card-btn">Add Task</VButton>
                    <VButton @clickHandler="cancelCreatingTask">Cancel</VButton>
                </div>
            </div>
            <div
                v-if="!list.newTask || (list.newTask && list.id !== listItem.id)"
                class="new-task new-task-btn-wrapper"
            >
                <Dropmenu
                    :down="tasks.length > 1 ? true : false"
                    :id="`newtemplate-${listItem.id}`"
                    class="dropmenu-holder"
                    :showList="listItem.openNewTask"
                >
                    <template #button>
                        <VButton
                            @clickHandler="toggleNewTaskTemplates()"
                            :fullWidth="true">+ New Task
                        </VButton>
                    </template>
                    <template #dropcontent>
                        <ul class="dropmenu-list">
                            <li
                                v-for="template in templateTasks"
                                :key="template.id"
                            > 
                                <div v-if="templateTasks.length === 1" class="help-text">
                                    When you mark a task as "template" it will be shown here.
                                    When you click on it here, every task you make will have the same task descripion.
                                </div>
                                <a href="#" @click.prevent="openNewCardModal(template)">
                                    {{ template.title }}
                                </a>
                            </li>
                        </ul>
                    </template>
                </Dropmenu>
            </div>
        </div>
    </div>
</template>

<script>
import {Container, Draggable} from "vue-smooth-dnd";
import {applyDrag, difference} from "@/mixins/helpers";
import TaskCard from "@/components/atoms/TaskCard.vue";
import Textfield from "@/components/atoms/Textfield.vue";
import VButton from "@/components/atoms/VButton";
import Dropmenu from "@/components/atoms/Dropmenu.vue";
import Tooltip from "@/components/atoms/Tooltip.vue";

export default {
    name: "TaskListContainer",
    components: {
        Container,
        Draggable,
        TaskCard,
        Textfield,
        Dropmenu,
        VButton,
        Tooltip,
    },
    props: ['listTitle', 'tasks', 'listItem', 'extendedList', 'list', 'listIndex', 'boardIndex', 'boardId', 'superBoard', "corresponding_boards"],
    data() {
        return {
            addTaskTitle: '',
            dropPlaceholderOptions: {
                className: "drop-preview",
                animationDuration: "150",
                showOnTop: false,
            },
        }
    },
    watch: {
        $route() {
            this.cancelCreatingTask()
        }
    },
    methods: {
        openEditTask(task, listItem) {
            this.$emit('openEditTask', task, listItem)
            this.list ? this.list.newTask = false : ''
            this.addTaskTitle = ''
        },
        createTask() {
            this.$emit('createTask', this.addTaskTitle)
            this.addTaskTitle = ''
            this.$refs['add-task-title-input'].$el.querySelector('input#new_task_title').focus()
        },
        cancelCreatingTask() {
            this.$emit('cancelCreatingTask')
            this.list.newTask = false
            this.addTaskTitle = ''
        },
        toggleNewTaskTemplates() {
            this.list ? this.list.newTask = false : ''
            this.$emit('toggleNewTaskTemplates', this.listItem, this.listIndex, this.boardIndex)
        },
        openNewCardModal(template) {
            this.addTaskTitle = ''
            this.$emit('openNewCardModal', this.listItem, this.listIndex, this.boardIndex, this.boardId, template)
            this.$forceUpdate()
        },
        toggleListOptionsPopUp() {
            this.$emit('toggleListOptionsPopUp', this.listItem, this.listIndex, this.boardIndex)
        },
        openEditModal(modalId) {
            this.$emit('openEditModal', modalId)
        },
        archiveList() {
            this.$emit('archiveList', this.listItem)
        },
        dragstart(dragResult) {
            this.$emit('dragstart', dragResult)
        },
        onCardDrop(dropResult) {
            this.$emit('onCardDrop', this.listItem, dropResult)
        },
        getCardPayload(listItem) {
            return (taskIndex) => {
                let payload = listItem.tasks[taskIndex]
                this.$emit('setCardPayload', payload)
                return payload;
            };
        },
        corresponding_boards_formatted(board) {
            if (this.corresponding_boards[this.corresponding_boards.length - 1] == board) {
                return board
            } else {
                return `${board}, `
            }
        }
    },
    computed: {
        templateTasks() {
            return this.$store.getters.templateTasks
        },
        activeBoard() {
            return this.$store.getters.activeBoard
        },
        activeBoardTasks() {
            return this.$store.getters.activeBoardTasks
        },
    }
}
</script>

<style lang="scss">
    .smooth-dnd-drop-preview-constant-class {
        border-radius: 6px;
        background: #2b30354d;
        backdrop-filter: blur(6px);
        border: 1px dashed rgba(41, 55, 67, 0.8);
        margin: 6px 0;
    }
    .smooth-dnd-no-user-select .task:hover {
        background-color: inherit;
    }
    .single-task-card {
        margin-bottom: 7px;

        &:last-child {
            margin-bottom: 0;
        }
    }
    .items-block {
        padding: 0px 3px 0px 0;
        margin: 7px 4px 7px 7px;
    }
    .new-task-wrapper {
        padding: 0 7px 7px;
    }

    .empty-list {

        .items-block {
            padding: 0 15px;
        }

        .new-task-btn-wrapper {
            padding-top: 0;
        }

        .smooth-dnd-container {
            min-height: 50px !important;

            &:empty {
                min-height: 30px !important;
            }
        }
    }
    .help-text {
        padding: 2px 4px;
        margin-bottom: 5px;
        border-radius: 3.454px;
        background: rgba(217, 217, 217, 0.10);
        font-size: 12px;
        font-weight: 300;
    }
</style>
